export class TypedEmitter {
    constructor() {
        this.listeners = new Map();
    }
    on(event, listener) {
        const set = this.listeners.get(event) ?? new Set();
        set.add(listener);
        this.listeners.set(event, set);
        return () => this.off(event, listener);
    }
    off(event, listener) {
        this.listeners.get(event)?.delete(listener);
    }
    emit(event, ...args) {
        const set = this.listeners.get(event);
        if (!set) {
            return;
        }
        [...set].forEach(listener => listener(...args));
    }
    removeAll() {
        this.listeners.clear();
    }
}
export class ValueStore {
    constructor(initial) {
        this.subscribers = new Set();
        this.getSnapshot = () => this.value;
        this.subscribe = (listener) => {
            this.subscribers.add(listener);
            return () => {
                this.subscribers.delete(listener);
            };
        };
        this.value = initial;
    }
    set(next) {
        if (Object.is(next, this.value)) {
            return;
        }
        this.value = next;
        [...this.subscribers].forEach(subscriber => subscriber());
    }
    update(mutator) {
        this.set(mutator(this.value));
    }
}
